/**
 * Get the backend API base URL with /api path
 *
 * REACT_APP_API_URL should be the base URL without /api
 * (e.g., https://aggregate-mdm-api.azurewebsites.net)
 *
 * This function ensures /api is always appended correctly.
 */
export const getApiBaseUrl = (): string => {
  const baseUrl = process.env.REACT_APP_API_URL;

  if (baseUrl) {
    // Production: Append /api to base URL
    return `${baseUrl}/api`;
  }

  // Development: Use localhost with /api
  return 'http://localhost:5200/api';
};

/**
 * Get just the backend base URL without /api
 * (for cases that need to construct their own paths)
 */
export const getBackendBaseUrl = (): string => {
  return process.env.REACT_APP_API_URL || 'http://localhost:5200';
};
